module.exports = __webpack_public_path__ + "img/mx_insurama.ccd6c0c7.svg";